module.exports = __webpack_public_path__ + "img/2022956-47-2.ed98f532.png";